import { useQuery } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export const useCampaignGroupsTable = () => {
  const { workplaceGivingService } = useServices()

  const [{ data, isLoading, errorMessage }, { refresh }] = useQuery(workplaceGivingService.getCampaignGroupsList, {})

  return { data, isLoading, errorMessage, refresh }
}
